import { CurrentClubLayout } from '@/layouts';

import { buildGetLayout } from './buildGetLayout';

export const ChallengeLayout = {
  buildGetStaticProps: CurrentClubLayout.buildGetStaticProps,
  buildGetStaticPaths: CurrentClubLayout.buildGetStaticPaths,
  buildGetLayout,
};
